import { useTranslation } from "react-i18next";

import UserAvatar from "@/components/media/UserAvatar";

import type { GroupParticipant } from "../../services/group";

type GroupMemberRowProps = {
  participant: GroupParticipant;
};

export default function GroupMemberRow({ participant }: GroupMemberRowProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <div className="flex items-center gap-3 px-6 py-2">
      <UserAvatar size="lg" user={participant} disableTooltip />
      <div className="min-w-0 flex-1">
        <span className="block truncate font-medium text-gray-700">
          {participant.first_name} {participant.last_name}
        </span>
        <span className="block truncate text-sm text-gray-400">
          {participant.position?.name || "-"}
        </span>
      </div>
      {participant.is_owner && (
        <span className="text-primary-600 shrink-0 text-xs font-medium">
          {t("Owner")}
        </span>
      )}
    </div>
  );
}
